export enum OfferType {
  PURCHASE = 1,
  SALE = 2
}
